import { Badge } from '../components/ui/badge';

export const leaveTypes = [
  { value: 'sick', label: 'Sick Leave' },
  { value: 'personal', label: 'Personal Leave' },
  { value: 'emergency', label: 'Emergency Leave' },
  { value: 'other', label: 'Other' }
];

export const getLeaveTypeLabel = (type) =>
  leaveTypes.find(t => t.value === type)?.label || type;

const statusConfig = {
  pending: { label: 'Pending', className: 'bg-[#D97706]/10 text-[#D97706] border-[#D97706]/20' },
  approved: { label: 'Approved', className: 'bg-[#2E4632]/10 text-[#2E4632] border-[#2E4632]/20' },
  rejected: { label: 'Rejected', className: 'bg-[#BC4749]/10 text-[#BC4749] border-[#BC4749]/20' }
};

export const LeaveStatusBadge = ({ status }) => {
  const config = statusConfig[status] || statusConfig.pending;
  return <Badge className={`${config.className} border`}>{config.label}</Badge>;
};
